import { render, staticRenderFns } from "./veStuMoralProgram.vue?vue&type=template&id=e3768760&scoped=true"
import script from "./veStuMoralProgram.vue?vue&type=script&lang=js"
export * from "./veStuMoralProgram.vue?vue&type=script&lang=js"
import style0 from "./veStuMoralProgram.vue?vue&type=style&index=0&id=e3768760&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3768760",
  null
  
)

export default component.exports